import type { Dispatch, SetStateAction } from "react";

/**
 * How a list provider pages its rows: numbered pages driven by the caller's
 * `page` state, or one growing list that loads the next batch on scroll.
 */
export type PaginationMode =
    | {
          type: "pages";
          page: number;
          setPage: Dispatch<SetStateAction<number>>;
      }
    | { type: "loadMore" };

export const LOAD_MORE_PAGINATION_MODE: PaginationMode = { type: "loadMore" };

/** The mode alone, for list providers that own their page state. */
export type PaginationType = PaginationMode["type"];
